const Filter = {
  Save: "Filter.Save",
  SaveAs: "Filter.SaveAs",
  SaveDefault: "Filter.SaveDefault",
  RemoveDefault: "Filter.RemoveDefault",
  Delete: "Filter.Delete",
  ReturnRelativeDates: "Filter.ReturnRelativeDates",
  SaveSuccessMessage: "Filter.SaveSuccessMessage",
  SetDefaultSuccessMessage: "Filter.SetDefaultSuccessMessage",
  SavedFilters: "Filter.SavedFilters",
  DeleteSuccessMessage: "Filter.DeleteSuccessMessage",
  }
export default Filter;